import { atom } from "recoil";

export interface BarMeasurement {
    x: number;
    y: number;
    width: number;
    height: number;
}

export const barMeasurementsAtom = atom<Record<number, BarMeasurement>>({
    key: "funnelBarMeasurments",
    default: {},
});
